import React, { Dispatch, FC, ReactNode, SetStateAction, useReducer } from "react";
import clsx from "clsx";
import { CssBaseline, Grid } from "@mui/material";
import { LayoutStyles } from "./styles/Layout.styles";
import { useLocation } from "react-router-dom";

// components
import Header from "./Header";
import Navigation from "./Navigation";
import Footer from "./Footer";
import IntercomComponent from "./Intercom";
import RouteItem from "src/model/RouteItem.model";
import { mainRoutes } from "src/config";
import { tabsType } from "src/pages/Profile";

// define interface to represent component props
interface NoFooterLayoutProps {
  routes?: RouteItem[];
  useDefaultTheme?: boolean;
  toggleTheme?: () => void;
  back?: boolean;
  eye?: boolean;
  title?: string;
  children: ReactNode;
  hideRightIcon?: boolean;
  clear?: boolean;
  hideFavourites?: boolean;
  displayTabs?: boolean;
  setSelectedTab?: Dispatch<SetStateAction<tabsType>>;
}

// functional component
const NoFooterLayout: FC<NoFooterLayoutProps> = ({
  routes = mainRoutes,
  toggleTheme,
  useDefaultTheme,
  children,
  back,
  title,
  hideRightIcon,
  hideFavourites,
  displayTabs,
  setSelectedTab,
}) => {
  const classes = LayoutStyles();
  const location = useLocation();
  const [open, toggle] = useReducer((state) => !state, false);
  const [isCoinPage, setIsCoinPage] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (location.pathname.slice(0, 6)) {
      setIsCoinPage((prev) => !prev);
    }
  }, []);

  return (
    <div className={classes.root}>
      <CssBaseline />

      <Header
        back={back}
        title={title}
        open={open}
        handleMenuOpen={toggle}
        toggleTheme={toggleTheme}
        useDefaultTheme={useDefaultTheme}
        eye={isCoinPage}
        hideRightIcon={hideRightIcon}
        hideFavourites={hideFavourites}
        displayTabs={displayTabs}
        setSelectedTab={setSelectedTab}
      />
      <Navigation routes={routes} open={open} handleMenuClose={toggle} />
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}>
        {children}
      </main>
      <Grid sx={{ display: { xs: "none", md: "block" } }}>
        {/* footer hidden on Mobile but visible up md */}
        <Footer />
      </Grid>
      <IntercomComponent />
    </div>
  );
};

export default NoFooterLayout;
